import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import InstagramIcon from "@mui/icons-material/Instagram";
import TelegramIcon from "@mui/icons-material/Telegram";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const linkStyle = {
  color: "#fff5ff",
  textDecoration: "none",
};

const ContactUs = () => {
  return (
    <>
      <Stack>
        <Typography sx={{ textAlign: "center" }} variant="h6">
          اطلاعات تماس با شرکت
        </Typography>
        {/* <Typography variant="h6">کارخانه:</Typography> */}
        <Divider sx={{ mt: 4, mb: 1 }}>کارخانه</Divider>
        <Typography variant="body1">
          گلپایگان - شهرک صنعتی گلپایگان - خیابان تعاون 2 - پلاک 202
        </Typography>
        <p>
          تلفن:{" "}
          <a style={linkStyle} href="tel:03157030">
            03157030
          </a>{" "}
          - <span> فکس: 03157248067</span>
        </p>
        <a
          style={{ margin: "0 auto" }}
          href="https://maps.app.goo.gl/NHuD14Sme3GdMxbc9?g_st=it"
        >
          <LocationOnIcon sx={{ fontSize: 48, color: "#c5c5c5" }} />
        </a>
        <Divider sx={{ mt: 1, mb: 1 }}>دفتر فروش تهران</Divider>
        <Typography variant="body1">
          تهران - بلوار آیت‌اله کاشانی - بین وفا آذر شمالی و عقیل - پلاک 348 -
          طبفه 3 - واحد 10{" "}
        </Typography>
        <p>
          تلفن:{" "}
          <a style={linkStyle} href="tel:02149154000">
            02149154000
          </a>{" "}
          -{" "}
          <a style={linkStyle} href="tel:02144036007">
            02144036007
          </a>
        </p>
        <a
          style={{ margin: "0 auto" }}
          href="https://maps.app.goo.gl/NHuD14Sme3GdMxbc9?g_st=it"
        >
          <LocationOnIcon sx={{ fontSize: 48, color: "#c5c5c5" }} />
        </a>
      </Stack>
      <Divider sx={{ mt: 1, mb: 1 }}>شبکه‌های اجتماعی</Divider>
      <Stack
        mt={2}
        justifyContent="center"
        alignItems="center"
        direction="row"
        spacing={2}
      >
        <a href="https://instagram.com/neginaluminium">
          <InstagramIcon sx={{ fontSize: 48, color: "#c5c5c5" }} />
        </a>
        <a href="https://t.me/neginaluminium">
          <TelegramIcon sx={{ fontSize: 48, color: "#c5c5c5" }} />
        </a>
      </Stack>
    </>
  );
};

export default ContactUs;
